import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import styles from './Carousel.module.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Arrow from './components/Arrow/Arrow';
import { Container } from 'common/components/Layout/Layout';

class Carousel extends Component {
  static propTypes = {
    className: PropTypes.string,
    settings: PropTypes.object
  };

  static defaultProps = {
    className: ''
  };

  defaultSettings = {
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    prevArrow: <Arrow pull="left" />,
    nextArrow: <Arrow pull="right" />
  };

  render() {
    const {
      defaultSettings,
      props: { children, settings }
    } = this;

    const sliderSettings = Object.assign(defaultSettings, settings);

    return (
      <Container>
        <Slider {...sliderSettings}>
          {children.map((child, index) => (
            <div key={index} className={styles.Slide}>
              {child}
            </div>
          ))}
        </Slider>
      </Container>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/common/components/Carousel/Carousel.js